export default __webpack_public_path__ + "static/media/anne.1dd9e66c.mp4";